import { FileHandlePlugin, FileHandler, type FileHandlerOptions } from "@tiptap/extension-file-handler"
import { PluginKey } from "@tiptap/pm/state"

import { sdk } from "../../../sdk"
import { AssetTypeAttachmentNode } from "../../nodes"

interface AssetTypeFileHandlerOptions extends Pick<FileHandlerOptions, "allowedMimeTypes"> {
	uuid: string
}

export const AssetTypeFileHandler = FileHandler.extend<AssetTypeFileHandlerOptions>({
	name: "AssetTypeFileHandler",
	addProseMirrorPlugins() {
		return [
			FileHandlePlugin({
				key: new PluginKey(this.name),
				editor: this.editor,
				allowedMimeTypes: this.options.allowedMimeTypes,
				onDrop: async (editor, files, pos) => {
					const [offlineAttachments, _promise] = await sdk.assetTypeAttachments.bulkAdd(
						files.map((file) => ({
							asset_type: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContentAt(
							pos,
							offlineAttachments.map((offlineAttachment) => ({
								type: AssetTypeAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
				onPaste: async (editor, files, _htmlContent) => {
					const [offlineAttachments, _promise] = await sdk.assetTypeAttachments.bulkAdd(
						files.map((file) => ({
							asset_type: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContent(
							offlineAttachments.map((offlineAttachment) => ({
								type: AssetTypeAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
			}),
		]
	},
})
